module.exports = __webpack_public_path__ + "img/Slice-34.28251e3e.svg";